import { i18n } from "@/i18n";
import RedirectedRoute from "@/views/RedirectedRoute/RedirectedRoute.vue";

export default {
  path: "/redirected-route",
  name: "redirectedRoute",
  component: RedirectedRoute,
  meta: {
    authRequired: false,
    title: i18n.global.t("dashboard.welcome_to_studea"),
    breadcrumb: false,
  },
};
